import React from 'react'

import { AgreementField } from '@/components/misc/CommercialAgreementsDetails/components/AgreementFields'

interface Props {
  field: AgreementField
}

const AgreementFieldRow: React.FC<Props> = ({ field }) => {
  const { label, value, visible = true, message } = field

  if (!visible) {
    return null
  }

  return (
    <div key={label?.toString()} className="border-b border-gray-200 px-1 py-2">
      <div className="flex flex-col justify-between gap-1 sm:flex-row">
        <strong className="text-black">{label}</strong>
        <span className="sm:text-right">{value}</span>
      </div>
      {message && <div>{message}</div>}
    </div>
  )
}

export default AgreementFieldRow
